import { render, staticRenderFns } from "./auto-message-template-restrictions-dialog.vue?vue&type=template&id=00c5be5d&scoped=true&"
import script from "./auto-message-template-restrictions-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-message-template-restrictions-dialog.vue?vue&type=script&lang=js&"
import style0 from "./auto-message-template-restrictions-dialog.vue?vue&type=style&index=0&id=00c5be5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5be5d",
  null
  
)

export default component.exports